import BaseApi from './BaseApi'

export default class StatisticsApi extends BaseApi {
    async getDeviceStatistics () {
        const response = await this.get('/api/v1.0/statistics/devices');

        return response;
    }
}
